import { Route } from "react-router-dom";
import {
  UserIcon,
  UserEdit,
  UserCreate,
  UserShow,
  UserPage,
} from "./views/users";
import {
  LocationIcon,
  LocationList,
  LocationEdit,
} from "./views/locations/locations";
import LocationCreate, {
  LocationBulkCreate,
} from "./views/locations/locationCreate";
import {
  SystemIcon,
  SystemList,
  SystemEdit,
  SystemCreate,
  SystemShow,
} from "./views/systems";
import {
  TowerIcon,
  TowerList,
  TowerEdit,
  TowerCreate,
  TowerBulkCreate,
  TowerTowerModelEdit,
  TowerStatusEdit,
  TowerIsOnlineEdit,
} from "./views/tower/towers";
import { TowerShow } from "./views/tower/TowerDetail";
import {
  LockerIcon,
  LockerList,
  LockerEdit,
  LockerShow,
  LockerKeypadEdit,
  LockerStatusEdit,
} from "./views/lockers";
import {
  ReservationList,
  ReservationIcon,
  ReservationShow,
} from "./views/reservations";
import {
  openLockerTokenIcon,
  OpenLockerTokenList,
  OpenLockerTokenShow,
} from "./views/openLockerTokens";
import {
  ClientsList,
  ClientsView,
  clientsEdit,
  clientsCreate,
  ClientIcon,
} from "./views/clients";
import {
  TowerModelCreate,
  TowerModelEdit,
  TowerModelIcon,
  TowerModelList,
} from "./views/tower_model/TowerModel";
import {
  TowerHistoryList,
  TowerHistoryListView,
  TowerHistoryShow,
} from "./views/towerHistory";

import {
  LockerProviderList,
  LockerProviderCreate,
  LockerProviderEdit,
  LockerProviderShow,
  BusinessViewIcon,
} from "./views/lockerProviders";

import {
  FederationCreate,
  FederationEdit,
  FederationList,
  FederationShow,
} from "./views/federatios";

import { KeyIcon, KeyList } from "./views/keys";
import { TowerModelShow } from "./views/tower_model/TowerModelDetail";
import {
  LocationFirmwareEdit,
  LocationShow,
} from "./views/locations/locationShow";
import { myCustomRoutes } from "./ra-lb-tools/components/customRoutes";
import {
  LockerUsageShow,
  RawLockerUsageList,
} from "./views/billing/lockerUsage";
import {
  LockerTypeCreate,
  LockerTypeEdit,
  LockerTypeIcon,
  LockerTypeList,
  LockerTypeShow,
} from "./views/lockerTypes";
import {
  OrganizationCreate,
  OrganizationEdit,
  OrganizationIcon,
  OrganizationList,
  OrganizationShow,
} from "./views/billing/organizations";
import {
  PlanCreate,
  PlanIcon,
  PlanList,
  PlanShow,
} from "./views/billing/plans";
import {
  ProductCreate,
  ProductIcon,
  ProductList,
  ProductShow,
} from "./views/billing/products";
import {
  PlanSubscriptionCreate,
  PlanSubscriptionIcon,
  PlanSubscriptionList,
  PlanSubscriptionShow,
} from "./views/billing/plan_subsciptions";
import {
  PriceIcon,
  PriceList,
  PricesCreate,
  ProductPriceList,
} from "./views/billing/prices";
import CommandsList from "./views/commands";
import EventsList from "./views/events";
import {
  DeviceEdit,
  DeviceIcon,
  DeviceList,
  DeviceShow,
} from "./views/devices";
import { DeviceHistoryIcon, DeviceHistoryList } from "./views/deviceHistory";
import {
  LocationFirmwareIcon,
  LocationFirmwareList,
  LocationFirmwareShow,
} from "./views/firmware";
import {
  PolicyCreate,
  PolicyEdit,
  PolicyIcon,
  PolicyList,
  PolicyShow,
} from "./views/policies";
import {
  LocationImageIcon,
  LocationImageList,
  LocationImageShow,
} from "./views/locationImage";
import { CustomRoutes, Resource } from "react-admin";
import { PermissionIcon, PermissionList } from "./views/permissions";
import { TaskCreate } from "./views/tasks";
import { RoomPreferences, Timeline, Webhook } from "@mui/icons-material";
import { LockerRequestList } from "./views/lockerRequest";
import { LockerUsageRecordsList } from "./views/billing/lockerUsageRecord";
import {
  LockerOpenRequestList,
  LockerOpenRequestShow,
} from "./views/lockerOpenRequest";
import {
  SPWebHooksCreate,
  SPWebHooksEdit,
  SPWebHooksList,
  SPWebHooksShow,
} from "./views/sp_webhooks";
import {
  LockerUsageEventList,
  LockerUsageEventShow,
} from "./views/billing/lockerUsageEvent";
import { LockerHistoryList } from "./views/lockerHistory";
import {
  OrganizationMemberCreate,
  OrganizationMemberData,
  OrganizationMemberIcon,
} from "./views/billing/organizationMembers";
import {
  DeviceAssemblyCreate,
  DeviceAssemblyEdit,
  DeviceAssemblyIcon,
  DeviceAssemblyList,
  DeviceAssemblyShow,
} from "./views/deviceAssembly";
import {
  OrgTowerEdit,
  OrgTowerShow,
  OrgTowersList,
} from "./views/org/org_towers";

import {
  SetupPlansList,
  SetupPlansShow,
  SetupPLanIcon,
} from "./views/setupPlans";
import { OrgLockerShow, OrgLockersList } from "./views/org/org_lockers";
import { UserRoleIcon, UserRoleList } from "./views/userRoles";
import { ClientInfoSearch } from "./views/client_info_search";
import { OrgClientsList, OrgClientsShow } from "./views/org/org_clients";
import { OrgOrganizationsShow } from "./views/org/org_organizations";
import {
  OrgLockerUsagesList,
  OrgLockerUsagesShow,
} from "./views/org/org_lockerUsage";
import {
  OrgSPWebHooksCreate,
  OrgSPWebHooksEdit,
  OrgSPWebHooksList,
  OrgSPWebHooksShow,
} from "./views/org/org_sp_webhooks";
import { OrgUsersList, OrgUsersShow } from "./views/org/org_users";
import { OrganizationSettingsUpdate } from "./views/billing/organizationSettings";
import { OrgLocationsList, OrgLocationsShow } from "./views/org/org_locations";
import {
  MinMaxGeneratorCreate,
  MinMaxGeneratorIcon,
  MinMaxGeneratorList,
} from "./views/billing/min_max_generators";
import { AddOneOffInvoiceItems } from "./views/billing/oneOffItems";
import { currencyAmount } from "./ra-lb-tools/components/currencyField";

export const resources = [
  <Resource
    name="towers"
    key="towers"
    list={TowerList}
    show={TowerShow}
    edit={TowerEdit}
    create={TowerCreate}
    icon={TowerIcon}
    options={{
      group: "Locker Configuration",
    }}
  >
    <Route path=":towerId/history" element={<TowerHistoryListView />} />
    <Route path=":id/model" element={<TowerTowerModelEdit />} />
    <Route path=":id/status" element={<TowerStatusEdit />} />
    <Route path=":id/is-online" element={<TowerIsOnlineEdit />} />
  </Resource>,
  <Resource
    name="org-towers"
    key="org-towers"
    list={OrgTowersList}
    show={OrgTowerShow}
    edit={OrgTowerEdit}
    icon={TowerIcon}
    options={{
      label: "My Towers",
      can: { roles: ["-superuser"] },
    }}
  />,
  <Resource
    name="org-lockers"
    key="org-lockers"
    list={OrgLockersList}
    show={OrgLockerShow}
    icon={LockerIcon}
    options={{
      debugOnly: true,
      label: "My Lockers",
      innerRoutes: [":id/status"],
      can: { roles: ["-superuser"] },
    }}
  >
    <Route path=":id/status" element={<LockerStatusEdit />} />
  </Resource>,
  <Resource
    name="org-clients"
    key="org-clients"
    list={OrgClientsList}
    show={OrgClientsShow}
    icon={ClientIcon}
    options={{
      label: "My Clients",
      can: { roles: ["-superuser"] },
    }}
  />,
  <Resource
    name="org-users"
    key="org-users"
    list={OrgUsersList}
    show={OrgUsersShow}
    icon={UserIcon}
    options={{
      label: "My Users",
      can: { roles: ["-superuser"] },
    }}
  />,
  <Resource
    name="org-organizations"
    key="org-organizations"
    list={OrgOrganizationsShow}
    show={OrgOrganizationsShow}
    icon={OrganizationIcon}
    options={{
      label: "My Organization",
      can: { roles: ["-superuser"] },
    }}
  >
    <Route path=":id/settings" element={<OrganizationSettingsUpdate />} />
  </Resource>,
  <Resource
    name="org-locker-usage"
    key="org-locker-usage"
    list={OrgLockerUsagesList}
    show={OrgLockerUsagesShow}
    icon={Timeline}
    options={{
      label: "My Locker Usages",
      can: { roles: ["-superuser"] },
    }}
  />,
  <Resource
    name="org-webhooks"
    key="org-webhooks"
    list={OrgSPWebHooksList}
    show={OrgSPWebHooksShow}
    create={OrgSPWebHooksCreate}
    edit={OrgSPWebHooksEdit}
    icon={Webhook}
    options={{
      debugOnly: true,
      label: "My Webhooks",
      can: { roles: ["-superuser"] },
    }}
  />,
  <Resource
    name="org-locations"
    key="org-locations"
    list={OrgLocationsList}
    show={OrgLocationsShow}
    icon={LocationIcon}
    options={{
      label: "My Locations",
      can: { roles: ["-superuser"] },
    }}
  />,
  <Resource
    name="locations"
    key="locations"
    list={LocationList}
    edit={LocationEdit}
    create={LocationCreate}
    show={LocationShow}
    icon={LocationIcon}
    options={{
      group: "Locker Configuration",
    }}
  >
    <Route path=":id/firmware" element={<LocationFirmwareEdit />} />
  </Resource>,
  <Resource
    name="tower-models"
    key="tower-models"
    list={TowerModelList}
    show={TowerModelShow}
    create={TowerModelCreate}
    edit={TowerModelEdit}
    icon={TowerModelIcon}
    options={{
      group: "Locker Configuration",
      can: { roles: ["superuser"] },
    }}
  />,
  <Resource
    name="systems"
    key="systems"
    list={SystemList}
    edit={SystemEdit}
    create={SystemCreate}
    show={SystemShow}
    icon={SystemIcon}
    options={{
      group: "Locker Configuration",
    }}
  />,
  <Resource
    name="tower-setup-plans"
    key="tower-setup-plans"
    list={SetupPlansList}
    show={SetupPlansShow}
    icon={SetupPLanIcon}
    options={{
      group: "Locker Configuration",
    }}
  />,
  <Resource
    name="locker-open-requests"
    key="locker-open-requests"
    list={LockerOpenRequestList}
    show={LockerOpenRequestShow}
    icon={RoomPreferences}
    options={{
      group: "Locker Open",
    }}
  />,
  <Resource
    name="webhooks"
    key="webhooks"
    list={SPWebHooksList}
    show={SPWebHooksShow}
    create={SPWebHooksCreate}
    edit={SPWebHooksEdit}
    icon={Webhook}
    options={{
      group: "Locker Open",
    }}
  />,
  <Resource
    name="organizations"
    key="organizations"
    list={OrganizationList}
    edit={OrganizationEdit}
    create={OrganizationCreate}
    show={OrganizationShow}
    icon={OrganizationIcon}
    options={{
      group: "billing",
    }}
  >
    <Route path=":id/settings" element={<OrganizationSettingsUpdate />} />
    <Route
      path=":id/one-off-invoice-items"
      element={<AddOneOffInvoiceItems />}
    />
  </Resource>,
  <Resource
    name="products"
    key="products"
    list={ProductList}
    show={ProductShow}
    create={ProductCreate}
    icon={ProductIcon}
    options={{
      group: "billing",
    }}
  >
    <Route path=":productId/prices" element={<ProductPriceList />} />
  </Resource>,
  <Resource
    name="prices"
    key="prices"
    list={PriceList}
    icon={PriceIcon}
    create={PricesCreate}
    recordRepresentation={(record) =>
      `${record.product_data?.name} (${currencyAmount(
        record.unit_amount / 100,
        record.currency
      )} ${record.billing_scheme})`
    }
    options={{
      group: "billing",
    }}
  />,
  <Resource
    name="plans"
    key="plans"
    list={PlanList}
    create={PlanCreate}
    show={PlanShow}
    icon={PlanIcon}
    options={{
      group: "billing",
    }}
  />,
  <Resource
    name="plan-subscriptions"
    key="plan-subscriptions"
    list={PlanSubscriptionList}
    create={PlanSubscriptionCreate}
    show={PlanSubscriptionShow}
    icon={PlanSubscriptionIcon}
    options={{
      group: "billing",
    }}
  />,
  <Resource
    name="min-max-generators"
    key="min-max-generators"
    icon={MinMaxGeneratorIcon}
    list={MinMaxGeneratorList}
    create={MinMaxGeneratorCreate}
    recordRepresentation={(record) =>
      `${record.towerModel?.name} (${record.firstTier} - ${record.secondTier})`
    }
    options={{
      group: "billing",
    }}
  />,
  <Resource
    name="locker-usage"
    key="locker-usage"
    list={RawLockerUsageList}
    show={LockerUsageShow}
    icon={Timeline}
    options={{
      group: "Billing Activity",
    }}
  />,
  <Resource
    name="locker-usage-events"
    key="locker-usage-events"
    list={LockerUsageEventList}
    show={LockerUsageEventShow}
    icon={Timeline}
    options={{
      group: "Billing Activity",
    }}
  />,
  <Resource
    name="users"
    key="users"
    list={UserPage}
    edit={UserEdit}
    create={UserCreate}
    show={UserShow}
    icon={UserIcon}
    options={{
      sortOrder: 42,
    }}
  />,
  <Resource
    name="lockers"
    key="lockers"
    list={LockerList}
    edit={LockerEdit}
    icon={LockerIcon}
    show={LockerShow}
    options={{
      group: "Setups",
      innerRoutes: [":id/keypad", ":id/status"],
    }}
  >
    <Route path=":id/keypad" element={<LockerKeypadEdit />} />
    <Route path=":id/status" element={<LockerStatusEdit />} />
  </Resource>,
  <Resource
    name="clients"
    key="clients"
    list={ClientsList}
    show={ClientsView}
    edit={clientsEdit}
    create={clientsCreate}
    icon={ClientIcon}
    options={{
      group: "Setups",
    }}
  />,
  <Resource
    name="federations"
    key="federations"
    list={FederationList}
    create={FederationCreate}
    edit={FederationEdit}
    show={FederationShow}
    options={{
      group: "Setups",
    }}
  />,
  <Resource
    name="locker-providers"
    key="locker-providers"
    list={LockerProviderList}
    create={LockerProviderCreate}
    edit={LockerProviderEdit}
    show={LockerProviderShow}
    icon={BusinessViewIcon}
    options={{
      group: "Setups",
    }}
  />,
  <Resource
    name="organization-member"
    key="organization-member"
    list={OrganizationMemberData}
    icon={OrganizationMemberIcon}
    options={{
      group: "Setups",
    }}
  />,
  <Resource
    name="__organization_members"
    key="__organization_members"
    create={OrganizationMemberCreate}
    icon={OrganizationIcon}
    options={{
      group: "billing",
      skipAllowedActionsCheck: true,
    }}
  />,
  <Resource
    name="devices"
    key="devices"
    list={DeviceList}
    show={DeviceShow}
    edit={DeviceEdit}
    icon={DeviceIcon}
    options={{
      group: "Setups",
    }}
  />,
  <Resource
    name="user-roles"
    key="user-roles"
    list={UserRoleList}
    icon={UserRoleIcon}
    options={{
      group: "Setups",
    }}
  />,
  <Resource
    name="policies"
    key="policies"
    list={PolicyList}
    create={PolicyCreate}
    edit={PolicyEdit}
    show={PolicyShow}
    icon={PolicyIcon}
    options={{
      group: "Setups",
      sortOrder: 100,
    }}
  />,
  <Resource
    name="permissions"
    key="permissions"
    list={PermissionList}
    icon={PermissionIcon}
    options={{
      group: "Setups",
      sortOrder: 101,
      can: true,
      debugOnly: true,
      skipAllowedActionsCheck: true,
    }}
  />,
  <Resource
    name="location-firmware"
    key="location-firmware"
    list={LocationFirmwareList}
    show={LocationFirmwareShow}
    icon={LocationFirmwareIcon}
    options={{
      group: "Setups",
    }}
  />,
  <Resource
    name="location-image"
    key="location-image"
    list={LocationImageList}
    show={LocationImageShow}
    icon={LocationImageIcon}
    options={{
      group: "Setups",
    }}
  />,
  <Resource
    name="device-assembly"
    key="device-assembly"
    list={DeviceAssemblyList}
    show={DeviceAssemblyShow}
    create={DeviceAssemblyCreate}
    edit={DeviceAssemblyEdit}
    icon={DeviceAssemblyIcon}
    options={{
      group: "Setups",
    }}
  />,
  <Resource
    name="locker-types"
    key="locker-types"
    list={LockerTypeList}
    edit={LockerTypeEdit}
    create={LockerTypeCreate}
    show={LockerTypeShow}
    icon={LockerTypeIcon}
    options={{
      group: "Setups",
      can: { roles: ["superuser"] },
    }}
  />,
  <Resource
    name="tasks"
    key="tasks"
    list={TaskCreate}
    icon={DeviceHistoryIcon}
    options={{
      group: "Setups",
    }}
  />,
  <Resource
    name="keys"
    key="keys"
    list={KeyList}
    icon={KeyIcon}
    options={{
      group: "Activity",
    }}
  />,
  <Resource
    name="reservations"
    key="reservations"
    list={ReservationList}
    icon={ReservationIcon}
    show={ReservationShow}
    options={{
      group: "Activity",
    }}
  />,
  <Resource
    name="open-locker-tokens"
    key="open-locker-tokens"
    list={OpenLockerTokenList}
    show={OpenLockerTokenShow}
    icon={openLockerTokenIcon}
    options={{
      group: "Activity",
    }}
  />,
  <Resource
    name="locker-requests"
    key="locker-requests"
    list={LockerRequestList}
    icon={LocationImageIcon}
    options={{
      group: "Activity",
    }}
  />,
  <Resource
    name="commands"
    key="commands"
    list={CommandsList}
    icon={openLockerTokenIcon}
    options={{
      group: "Activity",
    }}
  />,
  <Resource
    name="events"
    key="events"
    list={EventsList}
    icon={openLockerTokenIcon}
    options={{
      group: "Activity",
    }}
  />,
  <Resource
    name="tower-history"
    key="tower-history"
    list={TowerHistoryList}
    show={TowerHistoryShow}
    icon={openLockerTokenIcon}
    options={{
      group: "Activity",
    }}
  />,
  <Resource
    name="locker-history"
    key="locker-history"
    list={LockerHistoryList}
    icon={LockerIcon}
    options={{
      group: "Activity",
    }}
  />,
  <Resource
    name="device-history"
    key="device-history"
    list={DeviceHistoryList}
    icon={DeviceHistoryIcon}
    options={{
      group: "Activity",
    }}
  />,
  <Resource
    name="locker-usage-records"
    key="locker-usage-records"
    list={LockerUsageRecordsList}
    icon={LocationImageIcon}
    options={{
      group: "Billing Activity",
    }}
  />,
  <Resource
    name="locker-open-requests"
    key="locker-open-requests"
    list={LockerOpenRequestList}
    show={LockerOpenRequestShow}
    icon={RoomPreferences}
    options={{
      group: "Locker Open",
    }}
  />,
  <Resource
    name="webhooks"
    key="webhooks"
    list={SPWebHooksList}
    show={SPWebHooksShow}
    create={SPWebHooksCreate}
    edit={SPWebHooksEdit}
    icon={Webhook}
    options={{
      group: "Locker Open",
    }}
  />,
  <Resource
    name="client-info"
    key="client-info"
    list={ClientInfoSearch}
    options={{
      group: "Activity",
      can: { roles: ["superuser"] },
      skipAllowedActionsCheck: true,
    }}
  />,
  <CustomRoutes key="CustomRoutes">
    {myCustomRoutes()}
    <Route path="/locations/bulk-create" element={<LocationBulkCreate />} />
    <Route path="/towers/bulk-create" element={<TowerBulkCreate />} />
  </CustomRoutes>,
];
